// Generated by scripts/generate-public-surface.ts. Do not edit.

import type { CountryValidator } from "../../types";

import { createValidator } from "#stdnum-runtime";

const clabe: CountryValidator<"MX"> = createValidator(
  "mx.clabe",
  128,
);

export default clabe;
export const compact = clabe.compact;
export const format = clabe.format;
export const validate = clabe.validate;
export const generate = (): string =>
  clabe.generate?.() ??
  (() => {
    throw new Error(
      "Validator mx.clabe cannot generate values",
    );
  })();
